import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TrainersModel } from 'common/models/page-models/Trainers Model/trainers-data.model';
import { ViewTrainersListingModel } from 'common/models/page-models/View Trainers Model/view-trainers-params.odel';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { TrainersGridWidgetService } from 'common/widget/Trainers/trainers-grid-widget.services';
import { ViewTrainersGridWidgetService } from 'common/widget/Trainers/view-trainers-grid-widget.service';

 
@Injectable({
    providedIn: 'root'
})
export class ViewTrainersGridResolver extends GridResolver<TrainersModel, ViewTrainersListingModel> {
    constructor(
        protected fs: ViewTrainersGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}